module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-us",
    attrs: {
      "id": "aboutUs"
    }
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('about.hedingTopText'))
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('about.hedingSubText'))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "fade-up"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('about.headingText'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-hover",
    on: {
      "click": function($event) {
        _vm.openVideoModal('presentation')
      }
    }
  }, [_c('div', {
    staticClass: "btn orange",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_vm._v(_vm._s(_vm.$t('component.watchPromoVideo'))), _c('span')])])]), _vm._v(" "), _c('a', {
    staticClass: "more-about-us white",
    attrs: {
      "href": "#top",
      "data-scroll-offset": _vm.scrollOffset,
      "data-aos": "fade-up"
    },
    on: {
      "click": _vm.smoothScroll
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('component.moreAboutUs')))])])]), _vm._v(" "), _c('div', {
    staticClass: "heading clearfix",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "description"
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('about.headSectionTopText'))
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('about.headSectionText'))
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "certs",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "heading-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('about.ourCertsTitle'))
    }
  })]), _vm._v(" "), _c('certs')], 1), _vm._v(" "), _c('div', {
    staticClass: "our-team orange-bg"
  }, [_c('div', {
    staticClass: "top-text"
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('about.ourTeamTitle'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "description",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('about.ourTeamText'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, _vm._l((_vm.team), function(member) {
    return _c('div', {
      key: member.img,
      staticClass: "team-box"
    }, [_c('img', {
      attrs: {
        "src": 'static/img/team/' + member.img + '?2',
        "alt": member.name,
        "data-aos": "fade-up",
        "data-aos-delay": "100"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text",
      attrs: {
        "data-aos": "fade-up",
        "data-aos-delay": "200"
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(member.name))]), _vm._v(" "), _c('div', {
      staticClass: "role"
    }, [_vm._v(_vm._s(member.role))])])])
  }), 0)]), _vm._v(" "), _c('clients'), _vm._v(" "), _c('media-box'), _vm._v(" "), _c('footer-more-information', {
    attrs: {
      "modalpage": ''
    }
  }), _vm._v(" "), _c('footer-main')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-container"
  }, [_c('video', {
    staticClass: "header-video",
    attrs: {
      "src": "static/img/about-us/falcon.mp4",
      "autoplay": "",
      "loop": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image"
  }, [_c('figure', {
    staticClass: "hexagon-image",
    staticStyle: {
      "background-image": "url('static/img/about-us/why-us.jpg')"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('div', {
    staticClass: "hexTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "hexBottom"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divider",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "line-horizontal-start"
  }), _vm._v(" "), _c('div', {
    staticClass: "line-diagonal"
  }), _vm._v(" "), _c('div', {
    staticClass: "line-horizontal-end"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a27e629"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AboutUs.vue
// module id = 303
// module chunks = 0